import React, { Fragment,useEffect, useState } from "react";
import Header from "../common/Header";
import { Link, useParams } from "react-router-dom";
import Footer from "../common/Footer";
import ErrorIcon from "@mui/icons-material/Error";

const PaymentSuccess = ({amount, transaction_id, payment_id, payment_method}) => {
    let { type } = useParams();
 
    const [service_type, setServiceType] = useState("");
    useEffect(() => {
        const saved = localStorage.getItem('shipment_details');
        if (!saved) return;
        
        const payload = JSON.parse(saved);
        setServiceType(payload.type);
      
    }, []);
    return <Fragment>
        <Header type={type} />
         
        <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-8 text-center">
                <div className="flex justify-center mb-6">
                    <div className="bg-red-100 rounded-full p-4">
                        <ErrorIcon style={{ fontSize: 40, color: "#e74c3c" }} />
                    </div>
                </div>

                <h1 className="text-2xl font-semibold text-orange-600 mb-2">
                    Payment Cancelled Or Failed
                </h1>
                <h3 className="text-1xl font-semibold text-orange-600 mt-3 mb-3">Change Shipment Details or Payment Option?</h3>
                <div className="flex justify-between items-center">
                    <Link to={`/service/${service_type}`} className="w-full flex items-center justify-center gap-2 border border-red-300 text-red-700 font-medium py-3 rounded-md hover:bg-red-200 active:scale-[0.99] transition">Back to Shipment Detail</Link>
                </div>
            </div>
        </div>
        <Footer/>
    </Fragment>
}

export default PaymentSuccess;